import styled from 'styled-components';

import appTheme from '../../themes/Theme';
import { Color } from '../../constants/Color';

export const StyledWrapper = styled.div`
  background-color: ${appTheme.backgroundColor};
  min-height: 100vh;
  padding-top: 8px;
`;

export const StyledWrapIcon = styled.div`
  position: fixed;
  right: 16px;
  bottom: 16px;
  background-color: ${Color.AthensGray};
  border-radius: 4px;
  padding: 4px 12px;
`;
